import React from 'react';
// import { authRoles } from '../../auth/authRoles';

const purchaseRoutes = [
	{
		path: '/purchase-detail',
		component: React.lazy(() => import('./Detail')),
	},
	{
		path: '/purchase-record',
		component: React.lazy(() => import('./Record')),
	},
	{
		path: '/purchase-quantity',
		component: React.lazy(() => import('./Quantity')),
	},
	{
		path: '/purchase-transition',
		component: React.lazy(() => import('./Transition')),
	},
	{
		path: '/purchase-shipping',
		component: React.lazy(() => import('./Shipping')),
	},
	{
		path: '/purchase-inspect',
		component: React.lazy(() => import('./Inspect')),
	},
];

export default purchaseRoutes;
